export enum ACKStatusEnum {
  PENDING = 0,
  APPROVED,
  CHANGES_REQUESTED,
  FINISHED_REQUESTING_CHANGES,
}
